export default __webpack_public_path__ + "static/media/landscape.0387c803.png";